import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

// Automaticky natahne vsechny locale/domena JSON soubory z ./locales bez
// nutnosti rucne pridavat import pro kazdou novou domenu (viz
// docs/superpowers/specs/2026-08-24-i18n-cz-en-hyb-design.md, sekce C).
const localeFilesContext = require.context('./locales', true, /\.json$/);

function buildMessages() {
  const messages = {};
  localeFilesContext.keys().forEach((filePath) => {
    // filePath je napr. "./hyb/common.json"
    const match = filePath.match(/^\.\/([^/]+)\/([^/]+)\.json$/);
    if (!match) {
      return;
    }
    const [, locale, namespace] = match;
    if (!messages[locale]) {
      messages[locale] = {};
    }
    messages[locale][namespace] = localeFilesContext(filePath);
  });
  return messages;
}

// Cestina (cs i hyb, ktery je taky cesky text) ma 3 tvary mnozneho cisla
// (1 / 2-4 / 5+), na rozdil od vue-i18n defaultni 2-tvarove pluralizace
// (n===1 -> tvar0, jinak tvar1). Zpravy pro tahle locale, ktere pouzivaji
// $tc s 3 tvary oddelenymi '|', se rozhoduji timhle pravidlem misto defaultu.
function czechPluralRule(choice, choicesLength) {
  if (choicesLength < 3) {
    return choice === 1 ? 0 : 1;
  }
  if (choice === 1) {
    return 0;
  }
  if (choice >= 2 && choice <= 4) {
    return 1;
  }
  return 2;
}

export default new VueI18n({
  locale: 'hyb',
  fallbackLocale: 'hyb',
  silentFallbackWarn: true,
  messages: buildMessages(),
  pluralizationRules: {
    cs: czechPluralRule,
    hyb: czechPluralRule,
  },
});
